import { useMutation } from "@tanstack/react-query";

import { useUser } from "@/auth/session";
import { Alert } from "@/components/ui";
import { identity } from "@/lib/api";

export function VerifyEmailBanner() {
  const user = useUser();
  const resend = useMutation({ mutationFn: identity.resendVerification });
  if (user.email_verified) return null;
  return (
    <div className="mb-6">
      <Alert tone="warning">
        <span>Please verify {user.email}. Check your inbox for the link. </span>
        {resend.isSuccess ? (
          <span className="font-medium">Sent. Check your inbox.</span>
        ) : (
          <button
            className="font-medium underline"
            onClick={() => resend.mutate()}
            disabled={resend.isPending}
            aria-busy={resend.isPending}
          >
            Resend e-mail
          </button>
        )}
      </Alert>
    </div>
  );
}
